import * as Yup from "yup";

export const addCountrySchema = Yup.object().shape({
    name: Yup.string().max(50, "Trop long!").required("Obligatoire"),
  });